import { usePageSeo } from '../hooks/usePageSeo';

const PageSeoUpdater = (): null => {
    usePageSeo();
    return null;
};

export default PageSeoUpdater;
